import { render, staticRenderFns } from "./TqLoaderContainer.vue?vue&type=template&id=60e05d9b&scoped=true&"
import script from "./TqLoaderContainer.vue?vue&type=script&lang=js&"
export * from "./TqLoaderContainer.vue?vue&type=script&lang=js&"
import style0 from "./TqLoaderContainer.vue?vue&type=style&index=0&id=60e05d9b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e05d9b",
  null
  
)

export default component.exports